module.exports = __webpack_public_path__ + "static/img/index_light_image.d75f71b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_light_image.png
// module id = ZgR9
// module chunks = 1